import { z } from "zod";

export function getEditorName<
  T extends z.ZodObject<{ editor: z.ZodLiteral<string> }>,
>(schema: T): z.infer<T>["editor"] {
  // eslint-disable-next-line no-underscore-dangle
  return schema.shape.editor._def.value;
}
